<template>
  <div>
    <b-modal
      @cancel="hideModal"
      no-close-on-backdrop
      ref="qutation"
      size="xl"
      title="Quotation"
      hide-footer
    >
      <b-row>
        <b-col cols="8">
          <b-button
            variant="light"
            style="height: 35px; width: 150px"
            @click="toggleSidebar()"
            ><i class="fa fa-plus" aria-hidden="true"></i> CREATE</b-button
          ></b-col
        >
        <b-col cols="4" class="float-end">
          <input
            type="string"
            class="form-control"
            placeholder="search"
            style="margin-bottom: 10px; border-radius: 10px"
            v-model="query"
            @input="fetchQuotations"
          /> </b-col
      ></b-row>
      <b-row v-if="loading" class="d-flex justify-content-center">
        <b-spinner
          style="width: 3rem; height: 3rem"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </b-row>
      <b-row
        v-if="quotations.length == 0 && !loading"
        class="pl-3 pr-3 text-center"
      >
        <b-col>
          <b-alert show variant="warning">No Quotation Found!</b-alert>
        </b-col>
      </b-row>
      <!-- quotations List -->
      <b-row v-if="quotations.length != 0 && !loading">
        <b-col cols="12" class="text-center">
          <table class="table table-hover table-striped">
            <tbody>
              <tr>
                <th class="text-center">Reference Number</th>
                <th class="text-center">Date</th>
                <th class="text-center">Total Amount</th>
                <th class="text-center">Discount</th>
                <th class="text-center">Net Discount</th>
                <th class="text-center">Valid Date</th>
                <th class="text-center">Customer</th>
                <th class="text-center">Shop</th>
                <th class="text-center">Action</th>
              </tr>
              <tr
                v-for="(item, index) in quotations"
                :key="index"
                style="border-bottom: 1px solid #c1c1c1"
              >
                <td class="text-center">{{ item.reference_number }}</td>
                <td class="text-center">
                  {{ moment(item.date) }}
                </td>
                <td class="text-center">{{ item.total }}</td>
                <td class="text-center">{{ item.discount }}</td>
                <td class="text-center">{{ item.total - item.discount }}</td>
                <td class="text-center text-dark">
                  {{ moment(item.valid_date) }}
                </td>
                <td class="text-center">{{ item.customer.name }}</td>
                <td class="text-center">{{ item.shop.name }}</td>
                <td class="text-center">
                  <b-btn
                    variant="no-decoration"
                    class="text-danger"
                    @click="onClickItem(item.id)"
                  >
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </b-btn>
                  <i
                    class="fa fa-print"
                    aria-hidden="true"
                    style="color: blue"
                    v-b-toggle.bill-sidebar
                    @click="onSelect(item.id)"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-modal>
    <Sidebar :width="1000" id="bill-sidebar" title="Quotation" right>
      <PrintBill :data="qutationdata" />
    </Sidebar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Sidebar from "@/components/base/Sidebar";
import PrintBill from "./PrintBill";
export default {
  name: "Quotation",
  components: {
    Sidebar,
    PrintBill,
  },
  methods: {
    moment: function (date) {
      return moment(date).format("LL");
    },
    onSelect(id) {
      this.fetchQuatationInfo(id);
      this.hideModal();
    },
    fetchQuatationInfo(id) {
      this.$store
        .dispatch("quotation/fetchQuatation", { id: id })
        .then((res) => {
          this.qutationdata = res;
        });
    },
    fetchQuotations() {
      // this.loading = true;
      this.$store
        .dispatch("quotation/fetchQuotations", { query: this.query })
        .then((res) => {
          // this.loading = false;
        })
        .catch((err) => {
          // this.loading = false;
        });
    },

    showModal() {
      this.loading = true;
      setTimeout(() => {
        this.fetchQuotations();
      }, 200);
      this.$refs["qutation"].show();
      this.loading = false;
    },
    hideModal() {
      this.$refs["qutation"].hide();
    },

    toggleSidebar() {
      this.$store.dispatch("dashboard/toggleSidebar", "QUTATION");
      this.hideModal();
    },
    onClickItem(id) {
      this.$store.commit("dashboard/SET_SIDE_AREA", "QUTATION");
      const callback = (data) => {
        this.$store.commit("bill/SET_PRODUCT", data.values);
        this.$store.commit("bill/SET_CUSTOMER", data.customer);
      };

      this.$store.dispatch("quotation/fetchQuatation", { id: id, callback });
      this.hideModal();
    },
  },
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data: () => ({
    loading: false,
    query: null,
    qutationdata: null,
  }),
  computed: {
    ...mapState("quotation", ["quotations"]),
  },
};
</script>
<style></style>
